import React, { useEffect, useRef, useState } from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { OneClickPanel } from '../../panels/OneClickPanel';
import { CutoutFrame } from '../CutoutFrame';
import type { PrepareStep } from '../../../types/prepare';
const sequence: {
  step: PrepareStep;
  ms: number;
}[] = [{
  step: 'orienting',
  ms: 900
}, {
  step: 'supporting',
  ms: 1300
}, {
  step: 'layout',
  ms: 450
}];

/** The real 1-Click Print panel, running a simulated job with no effect on the build. */
export function PrepareDemo() {
  const [step, setStep] = useState<PrepareStep>('idle');
  const timers = useRef<number[]>([]);
  useEffect(() => () => timers.current.forEach(clearTimeout), []);
  const run = () => {
    timers.current.forEach(clearTimeout);
    timers.current = [];
    let at = 0;
    sequence.forEach(({
      step: s,
      ms
    }) => {
      timers.current.push(window.setTimeout(() => setStep(s), at));
      at += ms;
    });
    timers.current.push(window.setTimeout(() => setStep('done'), at));
  };
  const running = step !== 'idle' && step !== 'done';
  return <CutoutFrame label="1-Click Print panel" className="pointer-events-auto p-[8px]" data-id="element-994" data-mp="2u338g3hi5na7">
      <div className="mx-auto w-fit" data-id="element-995" data-mp="2u0z3rjbs4k8v">
        <OneClickPanel onClose={() => undefined} supportState={running ? 'generating' : step === 'done' ? 'generated' : 'none'} prepareStep={step} touchpoints={86} onRun={run} data-id="element-996" data-mp="38shlblkaemuc" />
      </div>
      <p className="mx-auto mt-[8px] flex w-[300px] items-center gap-[6px] rounded-[5px] bg-pf-blue-soft px-[8px] py-[6px] text-[11.5px] text-pf-ink" data-id="element-997" data-mp="2g32b2y0g4xzh">
        <ShieldCheckIcon className="h-[13px] w-[13px] shrink-0 text-pf-blue" strokeWidth={2.4} data-id="element-998" data-mp="2b621we8avf45" />
        {step === 'done' ? 'Protected areas kept 100% support-free' : 'Saved protected areas are respected at every step'}
      </p>
    </CutoutFrame>;
}